import { render, staticRenderFns } from "./ContentLogoRow.vue?vue&type=template&id=571bd7de&scoped=true&"
import script from "./ContentLogoRow.vue?vue&type=script&lang=js&"
export * from "./ContentLogoRow.vue?vue&type=script&lang=js&"
import style0 from "./ContentLogoRow.vue?vue&type=style&index=0&id=571bd7de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bd7de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
